import i18n from "@/plugins/i18n.js";
const successContext = i18n.messages[i18n.fallbackLocale].success;
const errorContext = i18n.messages[i18n.fallbackLocale].errors;
const timeout = 2500;

const snackbars = {
  loginSuccess: {
    message: successContext["loginSuccess"],
    color: "success",
    icon: "mdi-check",
    timeout: timeout,
  },

  logoutSuccess: {
    message: successContext["logoutSuccess"],
    color: "success",
    icon: "mdi-check",
    timeout: timeout,
  },
  clubNumNotFound(clubNum) {
    return {
      message: i18n.t("errors.clubNumNotFound", [clubNum]),
      color: "error",
      icon: "mdi-numeric-off",
      timeout: timeout,
    }
  },
  clubNumFound(clubNum) {
    return {
      message: i18n.t("success.clubNumFound", [clubNum]),
      color: "success",
      icon: "mdi-numeric",
      timeout: timeout,
    }
  },
  paymentOptionChanged(paymentOption) {
    return {
      message: i18n.t("payment.paymentoption_changed", [paymentOption]),
      color: "success",
      icon: "mdi-mdi-currency-usd",
      timeout: timeout,
    }
  },
  noHallsOrCourses: {
    message: successContext["noHallsOrCourses"],
    color: "error",
    icon: "mdi-check",
    timeout: 9999999999,
  },
  genericError: {
    message: errorContext["genericError"],
    color: "error",
    icon: "mdi-alert-circle-outline",
    timeout: timeout,
  },
  copiedValue: {
    message: successContext["copiedValue"],
    color: "success",
    icon: "mdi-content-copy",
    timeout: timeout,
  },
  tokenExpired: {
    message: errorContext["tokenHasExpired"],
    color: "error",
    icon: "mdi-lock-clock",
    timeout: timeout,
  },

  // #region course booking and reservation snackbars
  courseBookingAddSuccess: {
    message: successContext["courseBookingAddSuccess"],
    color: "success",
    icon: "mdi-cart",
    timeout: timeout,
  },
  courseBookingAddCourseIsFull: {
    message: successContext["courseBookingCourseIsFull"],
    color: "success",
    icon: "mdi-cart",
    timeout: timeout,
  },
  courseBookingAddCourseAleadyBooked: {
    message: successContext["courseBookingCourseAleadyBooked"],
    color: "success",
    icon: "mdi-cart",
    timeout: timeout,
  },

  courseBookingRemoveSuccess: {
    message: successContext["coursebookingRemoveSuccess"],
    color: "success",
    icon: "mdi-cart-off",
    timeout: timeout,
  },
  courseBookingRemoveCourseOrMemberNotFound: {
    message: errorContext["courseBookingCourseOrMemberNotFound"],
    color: "error",
    icon: "mdi-cart",
    timeout: timeout,
  },
  courseBookingRemoveCourseCannotBeCancelled: {
    message: errorContext["courseBookingCourseCannotBeCancelled"],
    color: "error",
    icon: "mdi-cart",
    timeout: timeout,
  },

  reservationAddSuccess: {
    message: successContext["reservationAddSuccess"],
    color: "success",
    icon: "mdi-bookmark-plus",
    timeout: timeout,
  },
  reservationAddNoCourseFoundOrNotReservable: {
    message: errorContext["courseReservingNoCourseFoundOrNotReservable"],
    color: "error",
    icon: "mdi-bookmark-plus",
    timeout: timeout,
  },
  reservationAddNoReservationForFullCourses: {
    message: errorContext["courseReservingNoReservationForFullCourses"],
    color: "error",
    icon: "mdi-bookmark-plus",
    timeout: timeout,
  },
  reservationAddAlreadyReserved: {
    message: errorContext["courseReservingAlreadyReserved"],
    color: "error",
    icon: "mdi-bookmark-plus",
    timeout: timeout,
  },

  reservationRemoveSuccess: {
    message: successContext["reservationRemoveSuccess"],
    color: "success",
    icon: "mdi-bookmark-remove",
    timeout: timeout,
  },
  reservationRemoveNoReservation: {
    message: errorContext["courseReservingNoReservation"],
    color: "error",
    icon: "mdi-cart-off",
    timeout: timeout,
  },
  reservationRemoveNoCourseOrMemberNotFound: {
    message: errorContext["courseReservingNoCourseOrMemberNotFound"],
    color: "error",
    icon: "mdi-cart-off",
    timeout: timeout,
  },

  // #endregion

  // #region hall booking snackbars
  hallBookingAddSuccess: {
    message: successContext["hallBookingAddSuccess"],
    color: "success",
    icon: "mdi-calendar-check",
    timeout: timeout,
  },
  hallBookingRemoveSuccess: {
    message: successContext["hallBookingRemoveSuccess"],
    color: "success",
    icon: "mdi-calendar-blank",
    timeout: timeout,
  },
  hallBookingRemoveAllSuccess: {
    message: successContext["hallBookingRemoveAllSuccess"],
    color: "success",
    icon: "mdi-calendar-multiple",
    timeout: timeout,
  },

  hallBookingMeetingFromToDurationNull: {
    message: errorContext["hallMeetingsFromToDurationNull"],
    color: "error",
    icon: "mdi-circle-off-outline",
    timeout: timeout,
  },
  hallBookingMeetingHallCouldNotBeFound: {
    message: errorContext["hallMeetingsHallCouldNotBeFound"],
    color: "error",
    icon: "mdi-soccer-field",
    timeout: timeout,
  },
  hallBookingMeetingDurationSmallerMinBookingDuration: (minimalBookingDuration) => {
    return {
      message: errorContext["hallMeetingsBookingBlockInvalid"].replaceAll("{0}", minimalBookingDuration),
      color: "error",
      icon: "mdi-clock-alert-outline",
      timeout: timeout,
    };
  },
  // #endregion

  paymentPayPalCaptureError: {
    message: errorContext["paymentPayPalCaptureError"],
    color: "error",
    icon: "mdi-cash-sync",
    timeout: timeout,
  },

  hallBookingHallNotFound: {
    message: errorContext["hallBookingHallNotFound"],
    color: "error",
    icon: "mdi-not-equal",
    timeout: timeout,
  },
  hallBookingHallBookingDisabled: {
    message: errorContext["hallBookingHallBookingDisabled"],
    color: "error",
    icon: "mdi-currency-usd-off",
    timeout: timeout,
  },
  hallBookingNoFreeMeeting: {
    message: errorContext["hallBookingNoFreeMeeting"],
    color: "error",
    icon: "mdi-calendar-alert-outline",
    timeout: timeout,
  },
};

export default snackbars;
